import styled from "styled-components";

export const FooterEl = styled.footer`
  padding: 1.2rem;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
